import { render, staticRenderFns } from "./InstructorSnippet.vue?vue&type=template&id=fc588886&scoped=true"
import script from "./InstructorSnippet.vue?vue&type=script&lang=js"
export * from "./InstructorSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc588886",
  null
  
)

export default component.exports